import CashierPage from '@/views/profile/CashierPage'

export default function CashierScreen() {
  return <CashierPage />
}
